//问号里面名字的翻译
const contentCon = {
//   '01': {
//     ID: '编号',
//     Simpson: '不知道',
//   },
//   'alpha_diversity_indices.txt': {
//     ID: '编号1111',
//     Simpson: '不知道111',
//   },
//   'Tax.stat.txt':{
//     'FE-POST-01':'序号',
//     'FC-POST-06':'序号1111111111',
// }
  'OTU ID': '序列ID',
  'Primer': '引物信息',
  'Samples': '样本名称',
  'Bases': '样本优化序列碱基数',
  'AverageLength': '优化数据的序列平均长度',
  'Df': '自由度',
  'F': 'F检验值',
  'SumOfSqs': '总方差，又称离差平方和',
  'SumsOfSqs': '总方差，又称离差平方和',
  'R2': '不同分组对样品差异的解释度，即分组方差与总方差的比值，R2越大表示分组对差异的解释度越高',
  'Pr': 'P值，小于0.05说明本次检验的可性度高',
  'taxonomy': '分类学系谱信息',
  'Taxonomy': '分类学系谱信息',
  'Total': '所有样本中注释到的不同分类学水平物种数目',
  'Observed_species': 'Observed_species指数，反映丰富度',
  'Chao1': 'Chao1指数，反映丰富度',
  'ACE': 'ACE指数，反映丰富度',
  'Shannon': 'Shannon指数，反映多样性',
  'Simpson': 'Simpson指数，反映多样性',
  'Pielou_J': 'Pielou均匀度指数，反映均匀度',
  'Pd_faith': '谱系多样性，反映进化多样性',
  'Phylum': '门水平物种',
  'Class': '纲水平物种',
  'Order': '目水平物种',
  'Family': '科水平物种',
  'Genus': '属水平物种',
  'Species': '种水平物种',
  'Sample_ID': "样本名",
  'cumsum': "物种累积的组间差异贡献比例",
  'Pr(>F)': "P值，小于0.05说明本次检验的可性度高",
  'MeanDecreaseAccuracy': '把一个变量的取值变为随机数，随机森林预测准确性的降低程度。该值越大表示该变量的重要性越大',
  'MeanDecreaseGini': '计算每个变量对分类树每个节点上观测值的异质性的影响，从而比较变量的重要性。该值越大表示该变量的重要性越大',
  '%IncMSE': 'increase in MSE。就是对每一个变量 比如 X1 随机赋值, 如果 X1重要的话, 预测的误差会增大,所以 误差的增加就等同于准确性的减少',
  'IncNodePurity': 'increase in Node Purity，如果是回归的话，node purity 其实就是 RSS（残差平方和residual sum of squares） 的减少， node purity 增加就等同于 Gini 指数的减少，也就是节点里的数据或 class 都一样，也就是 Mean Decrease Gini'
  // 'p.value06Wi':'差异物种组间wilcox rank-sum test的P-value'

}
const fate = {
  "code": 200,
  "message": "success",
  "data": [{
    "typeName": "img",
    "tags": [{
      "sonTag": [{
        "tagName": "Group_distance_diff_boxplot",
        "fileList": [{
          "filename": "Group_distance_diff_boxplot.pdf",
          "folder": "05.Beta/02.Distance/Bray_Curtis/Group_distance_diff_boxplot.pdf"
        }]
      }, {
        "tagName": "Group_distance_diff_jitter",
        "fileList": [{
          "filename": "Group_distance_diff_jitter.pdf",
          "folder": "05.Beta/02.Distance/Bray_Curtis/Group_distance_diff_jitter.pdf"
        }]
      }, {
        "tagName": "Group_distance_diff_violin",
        "fileList": [{
          "filename": "Group_distance_diff_violin.pdf",
          "folder": "05.Beta/02.Distance/Bray_Curtis/Group_distance_diff_violin.pdf"
        }]
      }],
      "tagName": "",
      "fileList": [{
        "filename": "Distance_heatmap.pdf",
        "folder": "05.Beta/02.Distance/Bray_Curtis/Distance_heatmap.pdf"
      }]
    }]
  }, {
    "typeName": "table",
    "tags": [{
      "tagName": "Group_distance_diff_test",
      "fileList": [{
        "filename": "Group_distance_diff_test.xls",
        "folder": "05.Beta/02.Distance/Bray_Curtis/Group_distance_diff_test.xls"
      }]
    }]
  }, {"typeName": "other", "tags": []}]

}
const menuList = [
  "01.OTU聚类和物种注释",
  '02.Alpha多样性分析',
  '03.物种组成分析',
  '04.Core分析',
  '05.Beta多样性分析',
  '06.差异分析',
  '07.环境因子分析',
  '08.随机森林分析',
  '09.FAPROTAX功能预测',
  '09.PICRUSt2功能预测',
  '09.Tax4Fun功能预测',
  '10.网络分析',
  "11.NeutralModel",
]

export function wordConvert(fileName, word, groupSampleNames) {
  // let arr=contentCon[fileName]
  // if(groupSampleNames.groupName&&groupSampleNames.sampleName){
  if(groupSampleNames.groupName){
    var groupNames = groupSampleNames.groupName.split(",")
    var sampleNames = groupSampleNames.sampleName.split(",")
    if (groupNames.indexOf(word) !== -1) {
      return "组名"
    }
    if (sampleNames.indexOf(word) !== -1) {
      return "样本名"
    }
    if (fileName === 'wilcox_all.xls') {
      if (word === "p.value") {
        return "差异物种组间wilcox rank-sum test的P-value"
      }
    }
    let value = contentCon[word]
    if (value) {
      return value
    } else {
      return word
    }
  }

  // }else {
  //   return word
  // }

}

export function getFate() {
  return fate
}
